import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router does not restore or honour `#section` anchors on its own. The
 * marketing nav links to homepage sections, so bring the behaviour back.
 */
export function useScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }

    // Wait a frame so the target section has been painted.
    const frame = requestAnimationFrame(() => {
      document.querySelector(hash)?.scrollIntoView({ block: 'start' });
    });

    return () => cancelAnimationFrame(frame);
  }, [hash, pathname]);
}
